import { bon } from './BON';
import { dlr } from './DLR';
import { tdlr } from './TDLR';
import { dmv } from './DMV';

export const AGENCY_ERRORS = { bon, tdlr, dmv, dlr };
